import { isNullOrUndefined } from "../../../common/utils";
import {
  DeleteActionOfPreviewKeyCondition,
  EditActionOfSelectKeyCondition,
} from "./DisplayLabelsClass";
import { KeyConditionAction } from "./model";
import {
  Confirm,
  Preview,
  ManageMembersByAdditionStep,
  ManageMembersByEditStep,
  SelectKeyCondition,
  SelectMethod,
} from "./stepsClass";

function getInitialDisplayLabels(action) {
  if (action === KeyConditionAction.EDIT) {
    return new EditActionOfSelectKeyCondition();
  } else if (action === KeyConditionAction.DELETE) {
    return new DeleteActionOfPreviewKeyCondition();
  }
  return null;
}

export function createSteps(action, isUGRevampEnabled) {
  const displayLabels = getInitialDisplayLabels(action);
  let steps = [];
  if (SelectMethod.isAdd(action) && !isUGRevampEnabled) {
    steps.push(new SelectMethod());
  }
  if (SelectKeyCondition.isAddOrEdit(action) && !isUGRevampEnabled) {
    const selectKeyConditionStep = new SelectKeyCondition();
    if (!isNullOrUndefined(displayLabels)) {
      selectKeyConditionStep.setDisplayLabels(displayLabels);
    }
    steps.push(selectKeyConditionStep);
  }
  if (ManageMembersByEditStep.isEdit(action) && isUGRevampEnabled) {
    steps.push(new ManageMembersByEditStep());
  }
  if (ManageMembersByAdditionStep.isAdd(action) && isUGRevampEnabled) {
    steps.push(new ManageMembersByAdditionStep());
  }
  const previewStep = new Preview();
  if (!isNullOrUndefined(displayLabels)) {
    previewStep.setDisplayLabels(displayLabels);
  }
  steps.push(previewStep);
  steps.push(new Confirm());
  return steps;
}
